import {initItemcardImages} from "../../../global/js/itemcardImages";
import {initRatingStars} from "../../../global/js/rating";
import {triggerCopyLink} from "../../../global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../global/js/subscriptions";
import {shareItemcardModal} from "../../../global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../global/js/variantSelectionSlider";
import {openFullscreenGallery} from "../../../global/js/fullscreengallery";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();

    for (let item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
    }
});